import type { Portfolio } from "~/typings/portfolio";

/**
 * Composable to sort experiences by start date in descending order (newest first)
 * @param experiences - Array of experience objects with startDate property
 * @returns Sorted array of experiences
 */
export function useSortExperiences(
  experiences: Portfolio.Experience[]
): Portfolio.Experience[] {
  return [...experiences].sort((a, b) => {
    const dateA = a.startDate ? new Date(a.startDate).getTime() : 0;
    const dateB = b.startDate ? new Date(b.startDate).getTime() : 0;

    // Descending order (newest first)
    return dateB - dateA;
  });
}
